export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#1C374C',
    light: '#FCF7F4',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FF5600',
    light: '#FFFFFF33',
    contrastText: '#22211F',
  },
  text: {
    brand: '#1C374C',
    primary: '#25272C',
    secondary: '#49515B',
    tertiary: '#626D7C',
    alternate: '#0F0F0F',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    hero1: '#002015B2',
    main: '#FFFFFF',
    default: 'rgba(234, 246, 255, 0.30)',
    paper: '#FFF',
    header: '#4E4E4E',
    footer: '#222427',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#1C374C',
    tableSubhead: '#F7F8F8',
    tableBorder: '#D7DBE0',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#112839',
    secondary: '#FAFAFA',
    light: '#F5F5F5',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    offer: '#EAF6FF',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
  },
  surface: {
    light: '#FCF7F4',
    grey: '#FAFAFA',
    pricing: '#DBB577',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#FF5600',
    unused: '#FCF7F4',
    unlimited: '#C0C0C0',
  },
};
